import {ChevronDownIcon, EyeIcon, File02Icon, Trash01Icon} from '@/components/ui/icon/Icon'
import {MenuItem} from '@/components/ui/menu-atoms/MenuAtoms'
import {useTranslation} from '@/translations/i18n'
import {MenuButton, MenuProvider} from '@ariakit/react'
import {UploadedDocument} from '@/types'
import {
    StyledFileDropdownMenu,
    StyledFileDropdownMenuDeleteButton,
    StyledFileDropdownMenuDisplayButton,
    StyledFileDropdownMenuSection,
    StyledFileDropdownMenuTrigger
} from './style'
import {Divider} from '@/components/ui/divider/Divider'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {CSSProperties} from 'react'

export const FileDropdownMenu = ({
    file,
    onDeleteFile,
    triggerWidth
}: {
    file: UploadedDocument
    onDeleteFile: (fileId: string) => void
    triggerWidth?: CSSProperties['width']
}) => {
    const {t} = useTranslation()

    return (
        <MenuProvider placement="bottom-end">
            <MenuButton
                render={
                    <StyledFileDropdownMenuTrigger
                        $width={triggerWidth}
                        size="md"
                        variant="secondary"
                        shape="rectangle"
                    >
                        <Flexbox gap={1} align="center">
                            <File02Icon />
                            <span>{file.name?.replace(/\s/g, '') || t('commons:document')}</span>
                        </Flexbox>
                        <ChevronDownIcon />
                    </StyledFileDropdownMenuTrigger>
                }
            />
            <StyledFileDropdownMenu gutter={8}>
                <StyledFileDropdownMenuSection>
                    <MenuItem
                        render={
                            <StyledFileDropdownMenuDisplayButton
                                to={file.url}
                                shape="rectangle"
                                variant="ghost"
                                target="_blank"
                            >
                                <EyeIcon size={18} />
                                {t('commons:display')}
                            </StyledFileDropdownMenuDisplayButton>
                        }
                    />
                </StyledFileDropdownMenuSection>

                <Divider direction="horizontal" />

                <StyledFileDropdownMenuSection>
                    <MenuItem
                        render={
                            <StyledFileDropdownMenuDeleteButton
                                onClick={() => onDeleteFile(file.id)}
                                shape="rectangle"
                                variant="ghost"
                            >
                                <Trash01Icon size={18} />
                                {t('commons:delete')}
                            </StyledFileDropdownMenuDeleteButton>
                        }
                    />
                </StyledFileDropdownMenuSection>
            </StyledFileDropdownMenu>
        </MenuProvider>
    )
}
